import {GridWidgetFilter} from './grid-widget-filter';
import {MultiField} from './multi-field';
import {GridWidgetDataField, DisableFilterOption} from './grid-widget-data-field';
import {RestArgument} from './rest-argument';
import { pdsUtils } from '../../pds-utils';

export class MultiFieldFilter extends GridWidgetFilter {

  searchValue: string; //This is the field that shows up in the UI.

  dataField: MultiField;

  filterInstances: Array<GridWidgetFilter> = [];

  constructor(dataField: MultiField) {
    super(dataField);
  }

  getTagName(): string {
    return 'pds-gw-multi-field-filter';
  }

  isBlank(): boolean {
    //This isn't likely to be called.
    let isBlank = this.searchValue == null || this.searchValue === '';
    return isBlank;
  }

  internalPassesFilter(dataFromDataRow: any): boolean {
    //No need to implement this actually.
    //Everything should be done in the overwriting of passesFilter
    return true;
  }

  passesFilter(dataRow): boolean {

    //Normally this function is not overwritten, but in this case we need to because
    //we aren't just working on one field

    let simpleFilterPassed = true;
    if (this.filterInstances != null && this.filterInstances.length > 0) {
      let passes = this.filterInstances.find((gwFilterObj: GridWidgetFilter) => {
        let pass = gwFilterObj.passesFilter(dataRow);
        // if (pass) {
        //   console.log('pass');
        // } else {
        //   console.log('fail');
        // }
        return pass;
      });
      simpleFilterPassed = (passes != null);
    }

    return simpleFilterPassed;
  }

  preFilterUpdate(): void {
    this.filterInstances = [];

    this.dataField.dataFields.forEach((dataField: GridWidgetDataField) => {

      //Exclude filters where the dataField is removed from simple filters.  (simpleOnly and both)
      if (dataField !== this.dataField && //Skip the dataField if it's the one in this.dataField.
          dataField.filterDisabled !== DisableFilterOption.simpleOnly &&
          dataField.filterDisabled !== DisableFilterOption.both) {

        let dataFieldFilter: GridWidgetFilter = dataField.getFilterInstance();
        let validQuickFilter = dataFieldFilter.setQuickSearchValue(this.searchValue);
        if (validQuickFilter) {

          //We only want to filter using filters that will actually
          //produce valid results.
          //NOTE: this is also handy because an invalid quick filter says that it is blank,
          //and passes everything.
          dataFieldFilter.preFilterUpdate();
          this.filterInstances.push(dataFieldFilter);
        }
      }
    });
  }

  setQuickSearchValue(text: string): boolean {
    this.searchValue = text || '';
    return true;
  }

  getRestArguments(): Array<RestArgument> {
    //It has been decided that the default "ALL" filter will not be in server side mode.
    //However, someone might try to use it anyway so here is a guess at what they will want.
    let value: Array<Array<RestArgument>> = [];
    for (let qf of this.filterInstances) {
      value.push(qf.getRestArguments());
    }
    return pdsUtils.flatten(value);
  }

  getTagText(): string {
    return this.searchValue;
  }

  getPersistenceObject(): Object | undefined {
    return this.searchValue;
  }

  restoreFromPersistenceObject(value: Object): void {
    this.searchValue = <string>value;
  }
}
